export default "__VITE_ASSET__Di3gN12b__"